import React from "react"
import Link from "gatsby-link"
import styled from "styled-components"
import * as vars from "../style/vars"
import { above, below, clearFix } from "../style/functions"
import { RichText, Date } from "prismic-reactjs"
import Video from "./video"
import Photo from "./photo"

const Card = ({
   tile_id = '',
   imageUrl,
   titleLeft, //only applicable for vertical layout
   titleRight,
   text,
   actionUrl,
   videoUrl,
   media_type = 'Image',
   carousel_images = [],
   publisherLogo,
   publisherUrl,
   passProperty,
   showSeparator = true,
   className,
   sub,
   source,
   btn,
   layout = "vertical",
   imageDirection = "left" //only applicable for horizontal layout
}) => {
   if (layout === "vertical_news") {
      return (
         <CardWrapper className={className} id={tile_id}>
            <div className="col col-12 img-news-item">
               <img src={imageUrl} alt={titleLeft} />
            </div>
            <div className="col col-xs-12">
               <div
                  className={`col col-xs-12 col-06 ${
                     titleLeft ? "" : "hide-below-tablet"
                     }`}>
                  <p className="text-center-above-tablet">{titleLeft}</p>
               </div>
               <div
                  className={`col col-xs-12 col-06 ${
                     showSeparator ? "border-left" : ""
                     }`}>
                  <h3>{titleRight}</h3>
                  <StyledLink className="btn-arrow" to={actionUrl}>
                     Read more
                  </StyledLink>
               </div>
            </div>
         </CardWrapper>
      )
   }
   if (layout === "main") {
      return (
         <CardWrapper className={"cf main " + className} id={tile_id}>
            <div className="col col-12 img-news-item">
               {videoUrl ? (
                  <Video url={videoUrl} poster={imageUrl} popup />
               ) : (
                     <Link to={actionUrl}>
                        <img draggable={false} src={imageUrl} alt={titleRight} />
                     </Link>
                  )}
            </div>
            <div className="col col-12 col-xs-12">
               <div
                  className={`col col-xs-03 col-02 date-wrapper ${
                     titleLeft ? "" : "hide-below-tablet"
                     }`}>
                  <p className="date">{titleLeft}</p>
               </div>
               <div
                  className={`col padd col-03 content ${
                     showSeparator ? "border-left" : ""
                     } ${titleLeft ? "col-xs-09" : "col-xs-12"}`}>
                  <h3>{titleRight}</h3>
                  {source && <span className="source">{source}</span>}
                  {/* {publisherLogo && (
                     <a href={publisherUrl} target="_blank">
                        <LogoImg src={publisherLogo} alt="Source logo" />
                     </a>
                  )} */}
               </div>
               <div
                  className={`col padd col-04 ${showSeparator ? "border-left" : ""} ${
                     titleLeft ? "col-xs-09" : "col-xs-12"
                     }`}>
                  <p>{text}...  </p>
                  {actionUrl && (
                     <div>
                        <StyledLink className="btn btn-arrow" to={actionUrl}>
                           {btn ? `${btn}` : "Read more"}
                        </StyledLink>
                     </div>
                  )}
               </div>
            </div>
         </CardWrapper>
      )
   }

   if (layout === "vertical") {
      return (
         <CardWrapper className={"cf " + className} id={tile_id}>
            <div className="col col-12 col-xs-12  img-news-item">
               {media_type === 'Carousel' && carousel_images.length > 0 && (
                  <Photo
                     slides={carousel_images}
                     adaptiveHeight={true}
                     isNewsCard={true}
                  />
               )}

               {media_type === 'YouTube' && videoUrl && (
                  <Video url={videoUrl} poster={imageUrl} popup />
               )}

               {media_type === 'Image' && imageUrl && (
                  (actionUrl ? (
                     <Link to={{
                        pathname: actionUrl,
                        state: { fromProp: titleRight }
                     }} >
                        <img draggable={false} src={imageUrl} alt={titleRight} />
                     </Link>
                  ) : (
                     <img draggable={false} src={imageUrl} alt={titleRight} />
                  ))
               )}
            </div>
            <div className="col col-12 col-xs-12">
               <div
                  className={`col col-xs-03 col-02 date-wrapper ${
                     titleLeft ? "" : "hide-below-tablet"
                     }`}>
                  <p className="date">{titleLeft}</p>
               </div>
               <div
                  className={`col padd col-10 content ${
                     showSeparator ? "border-left" : ""
                     } ${titleLeft ? "col-xs-09" : "col-xs-12"}`}>
                  <h3>{titleRight}</h3>
                  {source && <span className="source">{source}</span>}
                  {sub && <p className="sub-heading large">{sub}</p>}

                  {/* {publisherLogo && (
                     <a href={publisherUrl} target="_blank">
                     <LogoImg src={publisherLogo} alt="Source logo" />
                     </a>
                  )} */}
                  {text.length > 1 && !text.type ?
                     <p>{text}...</p>
                     : text._owner && (
                        <div>{text}</div>
                     )}
                  {actionUrl && (
                     <div>
                        {/* <StyledLink className="btn btn-arrow" to={actionUrl} state={{ fromFeed: true }}>
                           {btn ? `${btn}` : "Read more"}
                        </StyledLink> */}
                        <StyledLink className="btn btn-arrow" to={{
                           pathname: actionUrl,
                           state: { fromProp: titleRight }
                        }} >
                           {btn ? `${btn}` : "Read more"}
                        </StyledLink>
                     </div>
                  )}
               </div>
            </div>
         </CardWrapper >
      )
   }

   // horizontal layout
   return (
      <CardWrapper className={`${className} content-image align-${imageDirection}`} id={tile_id}>
         <div className="inner">
            <div
               className={`col col-xs-12 col-04 content padd-r ${
                  showSeparator ? "border-left" : ""
                  }`}>
               <h3>{titleRight}</h3>
               {source && <span className="source">{source}</span>}
               {sub && <p className="sub-heading large">{sub}</p>}
               {/* {publisherLogo && (
                  <a href={publisherUrl} target="_blank">
                     <LogoImg src={publisherLogo} alt="Source logo" />
                  </a>
               )} */}
               {text}
               {actionUrl && (
                  <div>
                     <StyledLink className="btn btn-arrow" to={actionUrl}>
                        {btn ? `${btn}` : "Read more"}
                     </StyledLink>
                  </div>
               )}
            </div>
            <div className="col col-xs-12 col-07 img-news-item">
               {media_type === 'Carousel' && carousel_images.length > 0 && (
                  <Photo
                     slides={carousel_images}
                     adaptiveHeight={true}
                     isNewsCard={true}
                  />
               )}

               {media_type === 'YouTube' && videoUrl && (
                  <Video url={videoUrl} poster={imageUrl} popup />
               )}

               {media_type === 'Image' && imageUrl && (
                  (actionUrl ? (
                     <Link to={{
                        pathname: actionUrl,
                        state: { fromProp: titleRight }
                     }} >
                        <img draggable={false} src={imageUrl} alt={titleRight} />
                     </Link>
                  ) : (
                     <img draggable={false} src={imageUrl} alt={titleRight} />
                  ))
               )}
            </div>
         </div>
      </CardWrapper>
   )
}

const CardWrapper = styled.div`
   padding-bottom: ${vars.padding.inner * 1.5}rem;
   .col {
      min-height: 31rem;
      ${below.tablet`
			min-height: 0;
		`};
   }
   &.main {
      img {
         max-height: 70rem;
         object-fit: cover;
         object-position: bottom center;
      }

      ${below.tablet`
			.col:last-of-type{
				float: right;
			}
		`};
   }
   .date {
      font-size: 1.2rem;
      ${below.mobile`
			font-size: 1.2rem;
		`};
   }
   .border-left {
      padding-left: 1.5rem;
      padding-bottom: 1rem;
      border-left: 1px solid ${vars.colors.body};
   }
   & .img-news-item img {
      width: 100%;
      margin-bottom: ${vars.padding.inner / 2}rem;
   }

   & .img-news-item:has(.slider) {
      ${below.desktop`
			clear: both;
		`};

      img, source {
         margin-bottom: 0;
      }
   }

   & .img-news-item .slider {
      margin-bottom: ${vars.padding.inner / 2}rem;

      .slick-list {
         width: 100%;
      }
   }

   p.bold {
      font-weight: bold;
   }
   &.content-image {
      &.align-left {
         .inner {
            padding-right: 13.25rem;
            padding-left: 0;
            ${clearFix()} ${below.giant`
				padding-right: 0;
			`};
         }
         .col:first-of-type {
            float: right;
         }
      }
      &.align-right {
         .col:last-of-type {
            float: right;
         }
      }
      ${below.tablet`
      display:flex;
      flex-direction: column-reverse;
    `};
   }

   .content {
      h3 {
         padding-top: 0;
         padding-bottom: 0;
      }
      p {
         padding: 1rem 0;
				 padding-right: 7rem;
				 ${below.desktop`
				 	padding-right: 0;
				 `}
      }
      a + div {
         padding: 3rem 0;
      }

      .sub-heading {
         padding: 2rem 0;
      }
   }

   .source {
      font-size: 1.4rem;
      font-style: italic;
      padding: 1rem 0 3rem;
      display: block;
      color: ${vars.colors.inactiveColor};
   }

   ${below.mobile`
  .border-left {
    padding-left: 1rem;
    padding-bottom: ${vars.padding.inner / 3}rem;
  }
`};
`

const StyledLink = styled(Link)`
   padding-bottom: 0;
   transition: all 0.3s;
   &:hover {
      margin-left: 1rem;
   }
`

const LogoImg = styled.img`
   max-width: 15rem;
   margin-top: 2rem;
`
export default Card



// WEBPACK FOOTER //
// ./src/components/news_card.js